import { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';

import { fetch_all, fetch_one } from '../../lib/server_helper';

// import {
//   IconButton
// } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import LaunchIcon from '@mui/icons-material/Launch';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { DataGrid } from '../../components/interface/DataGrid';
import { Page } from '../../components/interface/Page';
import { SearchBox } from '../../components/interface/SearchBox';
import { StyledButton } from '../../components/interface/StyledButton';
import { StyledIconButton } from '../../components/interface/StyledIconButton';

import { Static } from '../../models/Static';
import { loginAtom } from '../../lib/auth';

type ContentStaticsProps = {};

export const ContentStatics: FunctionComponent<ContentStaticsProps> = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [login, setLogin] = useAtom(loginAtom);
  const [statics, setStatics] = useState<Static[]>([]);
  const [staticsCount, setStaticsCount] = useState<number>(0);
  const [loader, setLoader] = useState<boolean>(true);
  const [removeLoader, setRemoveLoader] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("id DESC");
  const [s, setS] = useState<string>("");

  useEffect(() => {
    onSearch(s);
  }, [page, order]);

  const onRemove = (id: number) => {
    setRemoveLoader(true);
    fetch_one<Static>('/nl/v3/objects/remove', {
      object: 'static',
      ob: {
        id: id
      }
    }, (obs, complete_data) => {
      onSearch('');
      setRemoveLoader(false);
    }, (z) => {

    }, login);
  };

  const onSearch = (s: string) => {
    setLoader(true);
    fetch_all<Static>('/nl/v3/objects/fetch_all', {
      object: 'static',
      fields: ['id', 'identifier', 'alternate_name', 'body', 'lang_nl', 'lang_fr', 'enabled'],
      per_page: 20,
      page: page,
      order: order,
      filter: {
        search: s
      }
    }, (obs, complete_data) => {
      setStatics(obs);

      let count:number = 0;
      if (typeof(complete_data?.data) === 'object' && 'count' in complete_data?.data) count = complete_data?.data?.count;
      setStaticsCount(count);

      setLoader(false);
    }, (z) => {

    }, login);
  };

  const columns: GridColDef[] = [
    { field: 'identifier', headerName: 'Identifier', width: 500 },
    { field: 'alternate_name', headerName: 'Alternate names', width: 400 },
    { field: 'lang_nl', headerName: 'NL', width: 40, sortable: false, renderCell: (params) => <>
      {params?.value < 1 && <StarOutlineIcon sx={{color: 'red'}} />}
      {params?.value > 99 && <StarIcon sx={{color: theme.palette.tertiary?.main}} />}
      {params?.value <= 99 && params?.value >= 1 && <StarHalfIcon sx={{color: 'orange'}} />}
    </> },
    { field: 'lang_fr', headerName: 'FR', width: 40, sortable: false, renderCell: (params) => <>
      {params?.value < 1 && <StarOutlineIcon sx={{color: 'red'}} />}
      {params?.value > 99 && <StarIcon sx={{color: theme.palette.tertiary?.main}} />}
      {params?.value <= 99 && params?.value >= 1 && <StarHalfIcon sx={{color: 'orange'}} />}
    </> },
  ];

  return (
    <Page sx={{}} title="Statics" helper="statics" old_url="https://old.argenco.be/support/statics" actions={<>
      <StyledButton
        label="Create new"
        id='create_new'
        contained
        path={'/static/new'}
        sx={{marginRight: 3}}
        startIcon={<AddCircleOutlineIcon />}
      />
    </>}>
      <SearchBox
        simple={true}
        onSearch={(s) => {
          setPage(0);
          setS(s);
          onSearch(s);
        }}
        memo="statics"
      />
      <DataGrid
        action_count={3}
        actions={(params) => {
          return (<>
            <StyledIconButton color="primary" path={`/static/${params.row.id}`}>
              <VisibilityIcon />
            </StyledIconButton>
            {!removeLoader && <StyledIconButton destroyBtn color="primary" onClick={(e) => {
              onRemove(params.row.id);
            }}>
              <DeleteForeverIcon />
            </StyledIconButton>}
            <StyledIconButton color="primary" onClick={() => {
              window.open(`/static/${params.row.id}`, "_BLANk");
            }}>
              <LaunchIcon />
            </StyledIconButton>
          </>);
        }}
        getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
        objectCount={staticsCount}
        objects={(statics || []).map(u => ({
          ...u
        }))}
        columns={columns}
        loader={loader}
        onSortModelChange={(a, b) => {
          let a_0_field:string = a[0].field;
          setOrder([a_0_field, a[0].sort].join(' '));
        }}
        page={page}
        setPage={(p) => {setPage(p);}}
      />
    </Page>
  );
}
